import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import StoryCard from "./../shared/story-card";
import { HeroImage } from "../shared/hero-image";
import Breadcrumb from "./../shared/breadcrumbs";
import styles from "../text-story-page/styles.m.css";
import stylesListicle from "./styles.m.css";
import Icon from "../../../../atoms/icon";
import ImageCaption from "../shared/elements/image-caption";
import ResponsiveImageWithFallback from "../../../../atoms/responsive-image-with-fallback";
import { VikatanResponsiveContainer } from "../../../../rows/ad-free";
import StoryMidPromotion from "../../storyMidContent";
import { generateImageSources } from "../../../../utils/utils";

const ListicleStoryImageElement = ({ element }) => {
  return (
    <div className={`${stylesListicle["listicle-image"]}`}>
      <ResponsiveImageWithFallback
        className={stylesListicle["image-listicle"]}
        slug={element["image-s3-key"]}
        metadata={element["image-metadata"]}
        alt={element["image-caption"]}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [16, 9], screenWidthCoverage: 1 },
          { aspectRatio: [16, 9], screenWidthCoverage: 0.5 }
        )}
      />
      <ImageCaption element={element} />
    </div>
  );
};

ListicleStoryImageElement.propTypes = {
  element: {
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.string,
    "image-caption": PropTypes.string,
    "image-attribution": PropTypes.string
  }
};

function ListicleStory(props) {
  const renderSocialMedia = get(props, ["renderSocialMedia"], () => null);
  const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
  const renderFooter = get(props, ["renderFooter"], () => null);
  const renderSidebar = get(props, ["renderSidebar"], () => null);
  const section = get(props, ["story", "sections", "0"], null);
  const cardsToBeNumbered = get(props, ["story", "cards"], []).filter(card => card["card-type"] !== "introduction")
    .length;
  let cardIndex = props.story["bullet-type"] === "123" ? 1 : 0;
  const storyHeadline = get(props, ["story", "subheadline"], () => null);
  const renderRelatedArticle = get(props, ["renderRelatedArticle"], () => null);
  const singleCard = get(props, ["story", "cards"], null);
  const readMore = false;
  const cards = readMore ? singleCard.slice(0, 1) : singleCard;
  const cardLength = cards.length;

  const renderBullet = card => {
    if (card["card-type"] !== "introduction") {
      return (
        <div className={stylesListicle["bullet"]}>
          {props.story["bullet-type"] === "123" ? (
            <span className={stylesListicle["bullet-text"]}>{cardIndex++}</span>
          ) : props.story["bullet-type"] === "321" ? (
            <span className={stylesListicle["bullet-text"]}>{cardsToBeNumbered - cardIndex++}</span>
          ) : (
            <Icon type={"bullet-arrow"} className={stylesListicle["bullet-icon"]} />
          )}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="page-content">
      <div className={`container`}>
        <Breadcrumb subSection={section} config={props.config} />
      </div>
      <div className={`container ${styles["story-grid"]}`}>
        <div className={styles["main-content"]}>
          <article className={`${styles["story-body"]} ${stylesListicle["story-body"]} js-story`}>
            {renderHeaderCard({ className: stylesListicle["listicle-header"] })}
            <HeroImage story={props.story} className={styles["hero-image"]} icon="listicle" headline="Listicle" />
            {!readMore && renderSocialMedia()}
            <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
            <br />
            {cards &&
              cards.map((card, index) => {
                return (
                  <div key={card.id}>
                    <VikatanResponsiveContainer
                      placement={"text-story"}
                      adtype={parseInt(index + 1)}
                      story={props.story}
                      className="ad_300_250"
                    />
                    {renderBullet(card, index)}
                    <StoryCard
                      card={card}
                      story={props.story}
                      showCard={readMore}
                      cardLength={cardLength}
                      renderRelatedArticle={renderRelatedArticle}
                    />
                    {index === 1 && (
                      <div>
                        <StoryMidPromotion story={props.story} />
                      </div>
                    )}

                    <br />
                  </div>
                );
              })}
            <div id="we-story-end" />
            {renderFooter(readMore)}
          </article>
        </div>
        {renderSidebar()}
      </div>
    </div>
  );
}

ListicleStory.propTypes = {
  story: PropTypes.shape(),
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func
};

export { ListicleStory, ListicleStoryImageElement };
